import { useMutation } from '@tanstack/react-query'
import { useFeatureFlags } from '@node-space/hooks'
import { postConvertTransferDryRun, postQuoteEstimate } from 'services/WalletsService'
import { quoteEstimate } from 'types/wallets'

export const usePostQuoteEstimateMutation = () => {
  const { enableV3Convert } = useFeatureFlags()

  return useMutation({
    mutationFn: (props: quoteEstimate) =>
      enableV3Convert ? postConvertTransferDryRun(props) : postQuoteEstimate(props),
  })
}
